import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import GoToResolveAppLink from '../../../core/components/GoToResolveAppLink';

function WingetUpdatesDeviceUILinkCellRenderer(
  deviceCount: number | undefined,
  updateId: string | undefined
): ReactElement {
  const { t } = useTranslation();

  if (!deviceCount || !updateId) {
    return <span>{t('wingetUpdatesGrid.grid.headers.deviceWithCount', { count: 0 })}</span>;
  }

  return (
    <GoToResolveAppLink
      route={{
        path: '/devices/individual-devices?filters=:filters',
        params: { filters: JSON.stringify({ availableWingetUpdates: updateId }) }
      }}>
      {t('wingetUpdatesGrid.grid.headers.deviceWithCount', { count: deviceCount })}
    </GoToResolveAppLink>
  );
}

export default WingetUpdatesDeviceUILinkCellRenderer;
